import { ApplicationInsights } from "@microsoft/applicationinsights-web";

import env from "./env";

const connectionString = env.REACT_APP_ADMIN2_APPLICATION_INSIGHTS;

export const initializeAppInsights = (
  configuredConnectionString,
  ApplicationInsightsClient = ApplicationInsights
) => {
  if (!configuredConnectionString) {
    return null;
  }

  const client = new ApplicationInsightsClient({
    config: {
      connectionString: configuredConnectionString,
      enableAutoRouteTracking: true,
    },
  });

  client.loadAppInsights();
  return client;
};

const appInsights = initializeAppInsights(connectionString);

export default appInsights;